import { useState, useEffect } from 'react'
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '@/components/ui/dialog'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ImageUploadTab } from './image-upload-tab'
import { ImageGenerateTab } from './image-generate-tab'
import { AltTextInput } from './alt-text-input'

interface ImageReplacementModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onImageSelected: (imageUrl: string, altText: string) => void
  initialAltText?: string
  agentId: string
  draftId: string
}

export function ImageReplacementModal({
  open,
  onOpenChange,
  onImageSelected,
  initialAltText = '',
  agentId,
  draftId,
}: ImageReplacementModalProps) {
  const [altText, setAltText] = useState(initialAltText)

  useEffect(() => {
    if (open) {
      setAltText(initialAltText)
    }
  }, [open, initialAltText])

  const handleImageReady = (imageUrl: string) => {
    onImageSelected(imageUrl, altText)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Replace Image</DialogTitle>
        </DialogHeader>

        <Tabs defaultValue="upload">
          <TabsList className="w-full">
            <TabsTrigger value="upload" className="flex-1">Upload</TabsTrigger>
            <TabsTrigger value="generate" className="flex-1">Generate</TabsTrigger>
          </TabsList>

          <TabsContent value="upload">
            <ImageUploadTab
              agentId={agentId}
              draftId={draftId}
              onUploaded={handleImageReady}
            />
          </TabsContent>

          <TabsContent value="generate">
            <ImageGenerateTab
              agentId={agentId}
              draftId={draftId}
              onGenerated={handleImageReady}
            />
          </TabsContent>
        </Tabs>

        <AltTextInput value={altText} onChange={setAltText} />
      </DialogContent>
    </Dialog>
  )
}
